import React from "react";

function ActiveSales({fill}) {
  return (
    <>
      <svg
        width="21"
        height="14"
        viewBox="0 0 21 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.0004 0.75V6.75C21.0005 6.8984 20.9566 7.0435 20.8742 7.167C20.7918 7.2904 20.6746 7.3867 20.5375 7.4435C20.4004 7.5003 20.2495 7.5151 20.1039 7.4861C19.9584 7.4572 19.8247 7.3856 19.7198 7.2806L17.2504 4.81031L11.781 10.2806C11.7114 10.3504 11.6287 10.4057 11.5376 10.4434C11.4466 10.4812 11.349 10.5006 11.2504 10.5006C11.1519 10.5006 11.0543 10.4812 10.9632 10.4434C10.8722 10.4057 10.7894 10.3504 10.7198 10.2806L7.50042 7.0603L1.28104 13.2806C1.14031 13.4214 0.94944 13.5004 0.75042 13.5004C0.55139 13.5004 0.36052 13.4214 0.21979 13.2806C0.07906 13.1399 0 12.949 0 12.75C0 12.551 0.07906 12.3601 0.21979 12.2194L6.96979 5.46938C7.03945 5.39964 7.12216 5.34432 7.21321 5.30658C7.30426 5.26884 7.40185 5.24941 7.50042 5.24941C7.59898 5.24941 7.69657 5.26884 7.78762 5.30658C7.87867 5.34432 7.96139 5.39964 8.03104 5.46938L11.2504 8.6897L16.1901 3.75L13.7198 1.28063C13.6148 1.17573 13.5433 1.04204 13.5143 0.89648C13.4853 0.75092 13.5001 0.60002 13.557 0.46291C13.6138 0.32579 13.71 0.20861 13.8334 0.12621C13.9569 0.0438104 14.102 -0.000119755 14.2504 2.45189e-07H20.2504C20.4493 2.45189e-07 20.6401 0.0790201 20.7807 0.21967C20.9214 0.36032 21.0004 0.55109 21.0004 0.75Z"
          fill={fill}
        />
      </svg>
    </>
  );
}

export default ActiveSales;
